import styled from "@emotion/styled";

import { Tabs } from "metabase/ui";

export const TabsListSidebar = styled(Tabs.List)`
  overflow-y: auto;
  flex-wrap: nowrap;
`;
